import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  loggedInUserState: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: null,
  },
};

export const LoggedInUserSlice = createSlice({
  name: "LoggedInUser",
  initialState: INITIAL_STATE,
  reducers: {
    getLoggedInUser: (state) => {
      state.loggedInUserState.isLoading = true;
    },
    getLoggedInUserSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      loggedInUserState: {
        ...state.loggedInUserState,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    getLoggedInUserFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      loggedInUserState: {
        ...state.loggedInUserState,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
    clearLoggedInUser: (state) => ({
      ...state,
      loggedInUserState: {
        ...state.loggedInUserState,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: null,
        statusText: null,
        data: null,
      },
    }),
  },
});

export const {
  getLoggedInUser,
  getLoggedInUserSuccess,
  getLoggedInUserFailure,
  clearLoggedInUser,
} = LoggedInUserSlice.actions;
export const LoggedInUserReducer = LoggedInUserSlice.reducer;
